import React from 'react'
import PlanCompletePng from '~/assets/plan-complete.png'
import { Button } from '~/components/common/Button'
import { Modal } from '~/components/modals/CurieModal'
import { Typography } from '~/components/common/Typography'

interface CompleteDialogProps {
  isOpen: boolean
  onClose: () => void
}

const SuccessCheckIcon = ({ className }: { className?: string }) => (
  <svg
    width='48'
    height='48'
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='24' cy='24' r='24' fill='#8B5CF6' />
    <path d='M20.5 30.5L15 25L16.4 23.6L20.5 27.7L31.6 16.6L33 18L20.5 30.5Z' fill='white' />
  </svg>
)

const DecorativeStars = () => <img src={PlanCompletePng} alt='' />

export const CompleteDialog: React.FC<CompleteDialogProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[768px] h-[623px]'>
      <div className='p-16'>
        {/* Success Icon */}
        <div className='flex justify-center mb-6'>
          <SuccessCheckIcon />
        </div>

        {/* Heading */}
        <Typography
          fontFamily='geist'
          fontSize='titleLg'
          fontWeight='bold'
          className='text-black text-center mb-3'
        >
          You Are All Set
        </Typography>

        {/* Description */}
        <Typography
          fontFamily='geist'
          fontSize='bodyMd'
          fontWeight='medium'
          className='text-[rgba(0,0,0,0.65)] text-center mb-8 leading-[1.6]'
        >
          Your org account is now active. Start collaborating and using shared tokens and credits.
        </Typography>

        {/* Decorative Stars Section */}
        <div className='mb-8'>
          <DecorativeStars />
        </div>

        {/* Call to Action Button */}
        <div className='flex justify-center' aria-label='Start building button'>
          <Button variant='primary' className='w-full' onClick={onClose}>
            Let&apos;s Build
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CompleteDialog
